export const APP_NAME = "DEEPLY SMART";

export const APP_TAGLINE =
  "Your AI-powered personal knowledge base — capture, organize, and synthesize everything you learn.";

export const APP_DESCRIPTION =
  "DEEPLY SMART is an intelligent workspace that helps you build a lasting personal knowledge base. " +
  "Save documents, notes, and ideas; chat with AI that understands your context; and connect optional " +
  "Google integrations so your inbox and files feed into one searchable, growing intelligence layer.";

export const APP_FEATURES = [
  {
    title: "Capture & organize",
    description:
      "Import documents, web clips, and notes into a structured library with tags, topics, and spaces.",
  },
  {
    title: "AI chat & agents",
    description:
      "Ask questions grounded in your own knowledge. Deploy AI agents to research, summarize, and automate tasks.",
  },
  {
    title: "Google integrations",
    description:
      "Optionally connect Gmail and Google Drive to bring email and files into your workspace — read-only, on your terms.",
  },
  {
    title: "Progressive intelligence",
    description:
      "Connections, digests, and insights emerge as your knowledge base grows — your second brain gets smarter over time.",
  },
] as const;

export const APP_GOOGLE_DATA_NOTE =
  "Google integrations are optional. If you connect Google, DEEPLY SMART requests read-only access to Gmail " +
  "(gmail.readonly) and Google Drive so you can browse and analyze your content in-app. We never send, delete, " +
  "or modify your email. You can disconnect at any time from Settings.";

export const APP_SUPPORT_EMAIL = "support@deeplysmart.io";
